import { CircularProgress } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import ActionTable from "../../components/table/ActionTable";

export default function Categoria(props) {
  const { notification } = useContext(AppContext);
  const history = props.history;
  const [categoriaId] = useState(Number(props.match.params.id));
  const [dadosSub, setDadosSub] = useState("");
  const [categoria, setCategoria] = useState({});
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (categoriaId > 0) carregarCategoria();
  }, []);

  const carregarCategoria = () => {
    setCarregando(true);
    api
      .get("materiais/categorias/carregar", { id: categoriaId })
      .then((categoria) => {
        if (categoria.inativacao) {
          categoria.inativacao = categoria.inativacao.split(" ")[0];
        }
        setCategoria(categoria);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Não foi possível carregar a categoria");
        setCarregando(false);
      });
  };

  const salvar = (formulario) => {
    console.log("formulario", formulario);
    const categoria = formulario;

    if (categoriaId > 0) {
      categoria.id = categoriaId;
      api
        .post("materiais/categorias/editar", categoria)
        .then((res) => {
          notification("success", "Categoria salva!");
          history.push("/app/material-categoria");
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome não informado");
            case 2:
              return notification("error", "Produto inválido.");
            default:
              return notification("error", "Dados inválido.");
          }
        });
    } else {
      api
        .put("materiais/categorias/inserir", categoria)
        .then((res) => {
          notification("success", "Categoria salva!");
          history.push("/app/material-categoria");
        })
        .catch((err) => {
          const { data } = err;

          switch (data[0]) {
            case 1:
              return notification("error", "Nome não informado");
            case 2:
              return notification("error", "Produto inválido.");
            default:
              return notification("error", "Dados inválido.");
          }
        });
    }
  };

  const filtros = {
    title: categoriaId === 0 ? "Nova categoria" : "Editar categoria",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: categoria.nome ? categoria.nome : "",
        space: categoriaId === 0 ? 8 : 6,
      },
      produto: {
        label: "Produto",
        type: "select",
        emptyItem: true,
        emptyItemText: "(Todos)",
        space: categoriaId === 0 ? 4 : 3,
        options: [
          {
            value: 1,
            desc: "Bilíngue",
          },
          {
            value: 2,
            desc: "Uni Dune Tê",
          },
        ],
        value: categoria.produto,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },
    history,
    close: true,
  };

  if (categoriaId > 0) {
    filtros.form.inativacao = {
      label: "Inativacao",
      type: "date",
      value: categoria.inativacao ? categoria.inativacao : "",
      space: 3,
    };
  }

  // const formulario = () => {
  //     nome: {
  //       label: "Nome",
  //       type: "text",
  //       value: categoria.nome ? categoria.nome : "",
  //       space: categoriaId === 0 ? 8 : 6,
  //     },
  //     produto: {
  //       label: "Produto",
  //       type: "select",
  //       emptyItem: true,
  //       emptyItemText: "(Todos)",
  //       space: categoriaId === 0 ? 4 : 3,
  //       options: [
  //         {
  //           value: 1,
  //           desc: "Bilíngue",
  //         },
  //         {
  //           value: 2,
  //           desc: "Uni Dune Tê",
  //         },
  //       ],
  //       value: categoria.produto,
  //     },
  // };

  // const fCategoria = {
  //   form: formulario(),
  //   title: categoriaId > 0 ? "Editar categoria" : "Nova categoria",
  //   submit: {
  //     label: "Salvar",
  //     action: this.salvar,
  //   },
  //   closeButton: true,
  //   history: this.props.history,
  // };

  const salvarSubcategoria = (form) => {
    const subCategoriaSalvar = {
      id: dadosSub.subcategoriaId,
      nome: form.nome,
      categoriaId,
    };

    if (dadosSub.subcategoriaId > 0) {
      api
        .post("materiais/categorias/editarSubcategoria", subCategoriaSalvar)
        .then((res) => {
          if (res) {
            notification("success", "Subcategoria salva!");
            setDadosSub("");
            return carregarCategoria();
          } else {
            notification(
              "warning",
              "Não foi possível salvar. Verifique as informações."
            );
          }
        })
        .catch((e) => notification("error", "Erro ao salvar a subcategoria"));
    } else {
      api
        .put("materiais/categorias/inserirSubcategoria", subCategoriaSalvar)
        .then((res) => {
          if (res.id > 0) {
            notification("success", "Subcategoria salva!");
            setDadosSub("");
            return carregarCategoria();
          } else {
            notification(
              "warning",
              "Não foi possível salvar. Verifique as informações."
            );
          }
        })
        .catch((e) => notification("error", "Erro ao salvar a subcategoria"));
    }
  };

  const filtrosSub = {
    title: dadosSub.subcategoriaNome
      ? "Editar subcategoria"
      : "Nova subcategoria",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        value: dadosSub.subcategoriaNome ? dadosSub.subcategoriaNome : "",
      },
    },

    submit: {
      label: "Salvar",
      action: salvarSubcategoria,
    },

    close: {
      label: "Fechar",
      action: () => setDadosSub(""),
    },
  };

  const tRegistros = {
    title: "Subcategorias",
    newItemAction: () => setDadosSub({}),
    onLineClick: (sub) => {
      setDadosSub(sub);
    },
    columns: [
      {
        label: "Nome",
        name: "subcategoriaNome",
      },
    ],
    array: categoria.subcategorias,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          {dadosSub ? (
            <Form formData={filtrosSub} />
          ) : (
            <ActionTable structure={tRegistros} />
          )}
        </>
      )}
    </div>
  );
}
